module.exports = __webpack_public_path__ + "static/img/CAMBRIDGE-OAK.e0df434.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/CAMBRIDGE-OAK.png
// module id = FIT1
// module chunks = 0